export default {
  install(Vue) {
    Vue.prototype.get_education_degree = async function() {
      const api = `${window.endpoints.api}/BasicInformation/EducationDegree`;

      const response = await this.$http.get(api);
      const sorted = response.data.sort((a, b) => a.Seq - b.Seq);

      return sorted.map(({ Guid, Name }) => ({
        EducationDegreeGuid: Guid,
        EducationDegree: Name
      }));
    };
  }
};